// src/pages/HomePage.desktop.js

import React from 'react';
import {
  Container, Box, Typography, Button, Stack, Accordion,
  AccordionSummary, AccordionDetails, Grid, Avatar, ButtonBase,
} from '@mui/material';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { motion } from 'framer-motion';

// Component Imports
import BlurText from '../components/BlurText';
import RotatingText from '../components/RotatingText';
import fresh from "../assets/Main_EDIT_FRUITS_C.png";



// This component now only receives props needed for the page content itself.
function HomePageDesktop(props) {
  const {
    navigate, containerVariants, itemVariants
  } = props;

  return (
    <>
      {/* SECTION 1: Main Landing Content */}
      <Box sx={{ minHeight: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', backgroundColor: '#F0F5E4', overflow: 'hidden', position: 'relative', p: 3 }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
          <svg viewBox="0 0 800 880" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
            <path d="M0,0 L400,0 C 350,220 450,330 400,440 S 350,660 400,880 L0,880 Z" fill="white" />
          </svg>
        </Box>
        <Container maxWidth="lg" sx={{ position: 'relative' }}>
          <Grid container alignItems="center" spacing={4}>
            {/* LEFT COLUMN: Text Content */}
            <Grid item xs={12} md={6}>
              <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <motion.div variants={itemVariants}>
                  <Typography variant="h2" component="h1" fontWeight={800} sx={{ color: '#212121' }}>Fresh Produce</Typography>
                  <Typography variant="h2" component="h1" fontWeight={800} sx={{ color: '#212121' }}>Backed by ...</Typography>
                  <Typography variant="h2" component="h1" fontWeight={700} gutterBottom>
                    <Box sx={{ display: 'inline-flex', ml: 0, mt: 0, bgcolor: '#75a84b', overflow: 'hidden', borderRadius: 2, color: 'white', fontSize: '2.8rem' }}>
                      <RotatingText texts={['GREAT SERVICE', 'LOW PRICES']} mainClassName="px-3 bg-orange-500 text-white overflow-hidden py-2 justify-center rounded-lg" staggerFrom={"last"} initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "-120%" }} staggerDuration={0.025} splitLevelClassName="overflow-hidden pb-1" transition={{ type: "spring", damping: 30, stiffness: 400 }} rotationInterval={4000} />
                    </Box>
                  </Typography>
                </motion.div>
                <motion.div variants={itemVariants}>
                  <Box sx={{ my: 4, maxWidth: '500px' }}>
                    <BlurText text="Premium fruits and vegetables, delivered straight to your business 7 days a week. Count on us for consistent quality, unbeaten prices and reliable service you can trust." delay={150} animateBy="words" direction="top" className="text-xl" />
                  </Box>
                </motion.div>
                <motion.div variants={itemVariants}>
                  <Stack direction="row" spacing={2} sx={{ mb: 5 }}>
                    <Button variant="contained" size="large" sx={{ py: 1.5, px: 5, minWidth: "220px", fontWeight: 'bold', bgcolor: '#75a84b', color: 'white', '&:hover': { bgcolor: '#16A34A' }, borderRadius: '50px', textTransform: 'none', fontSize: '1rem' }} onClick={() => navigate('/register')}>Become a Customer</Button>
                    <Button variant="contained" size="large" sx={{ py: 1.5, px: 5, fontWeight: 'bold', minWidth: "220px", bgcolor: '#75a84b', color: 'white', '&:hover': { bgcolor: '#16A34A' }, borderRadius: '50px', textTransform: 'none', fontSize: '1rem' }} onClick={() => navigate('/login')}>Login to Order</Button>
                  </Stack>
                </motion.div>
                <motion.div variants={itemVariants}>
                  <Stack direction="row" spacing={3} alignItems="center">
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ color: '#424242' }}>
                      <InstagramIcon />
                      <Typography variant="body1" fontWeight="medium">@MataxExpress</Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ color: '#424242' }}>
                      <FacebookIcon />
                      <Typography variant="body1" fontWeight="medium">@MataxExpress</Typography>
                    </Stack>
                  </Stack>
                </motion.div>
              </motion.div>
            </Grid>
            {/* RIGHT COLUMN: Grocery Illustration */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 450 }}>
                <Box component="img" src={fresh} alt="Grocery Illustration" sx={{ position: 'relative', top: '-80px', left: '100px', maxWidth: '100%', maxHeight: '100%', border: 'none', boxShadow: 'none', objectFit: 'contain' }} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>




    </>
  );
}

export default HomePageDesktop;